import React, { useState } from "react";
import {
  InputField,
  Modal,
  SearchInput,
  Steps,
  SubmitButton,
  TextComponent,
  TimeInput,
} from "../../../../components";
import styles from "./groupAssets.module.css";
import { Checkbox, List, Popover } from "antd";
import { PiSealCheck } from "react-icons/pi";
import { TbDeviceRemote } from "react-icons/tb";
import { LuCircleDot } from "react-icons/lu";
import assetsAssignImg from "../../../../assets/images/car.png";
import { FiClock } from "react-icons/fi";
import { IoMdAddCircle } from "react-icons/io";

const AddNewGroupAssetModal = ({ isOpen, setIsOpen }) => {
  const [success, setSuccess] = useState(false);
  const [step, setStep] = useState(1);
  const [frequency, setFrequency] = useState("One time");
  const [status, setStatus] = useState("Immobilized");

  const assets = [
    {
      id: 2,
      title: "Honde accord",
      version: "1.0.5",
      img: require("../../../../assets/images/staticImages/c1.png"),
    },
    {
      id: 6,
      title: "Honde accord",
      version: "1.0.5",
      img: require("../../../../assets/images/staticImages/c1.png"),
    },
  ];

  const onChange = (e) => {
    console.log(`checked = ${e.target.checked}`);
  };

  const renderAssets = (item) => {
    return (
      <div className={styles.moduleCont}>
        <div className={styles.moduleSubCont}>
          <img
            className={styles.moduleImg}
            src={item?.img}
            alt="Device image"
          />
          <TextComponent text={item?.title} className={styles.heading} />
        </div>

        <Checkbox onChange={onChange} />
      </div>
    );
  };

  const onPressSave = () => {
    setSuccess(true);
    setIsOpen(false);
  };

  const onPressBack = () => {
    setIsOpen(false);
  };

  return (
    <>
      {isOpen && (
        <Modal
          open={isOpen}
          onCancel={() => setIsOpen(false)}
          // icon={

          // }
          // title={"Connect Module"}
          width={"800px"}
          twoButton
          okBtnTitle={"Add"}
          cancelBtnTitle={"Go back"}
          btnDiv={styles.access_modalBtn}
          onClickCancelButton={onPressBack}
          onClickOkButton={onPressSave}
          btnStyle={{ width: "80%" }}
          // headingClass={styles.modalHeading}
        >
          <div className={styles.mainCont}>
            {/* <Steps steps={steps} currentStep={step} /> */}
            <img src={assetsAssignImg} className={styles.carImg} />
            <TextComponent
              id={"title"}
              text={"Add New vehicle"}
              className={styles.heading2}
            />
            {/* <InputField
              label={"Group name"}
              className={styles.formDivideInput}
              // placeholder={"Write here"}
              // value={name}
              // onChange={(e) => setName(e.target.value)}
            /> */}
            <SearchInput />
            <List
              dataSource={assets}
              renderItem={renderAssets}
              style={{ width: "100%" }}
            />
            <TextComponent text={"+4 more"} className={styles.more} />
          </div>
        </Modal>
      )}
      <Modal
        open={success}
        onCancel={() => setSuccess(false)}
        icon={
          <PiSealCheck
            style={{ width: "100%", height: "100%", objectFit: "contain" }}
          />
        }
        title={"Vehicle Added Successfully"}
        width={"400px"}
        buttonTitle={"Continue"}
        onBtnPress={() => {
          setSuccess(false);
        }}
        headingClass={styles.modalHeading}
      ></Modal>
    </>
  );
};

export default AddNewGroupAssetModal;
